import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as DownstreamOwnersFilteredByFieldQuery
export const DownstreamOwnerIdsFilteredByFieldQueryGql: DocumentNode = gql`
query DownstreamOwnerIdsFilteredByFieldQuery($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
